var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DataTableRequest_request;
import { isNullOrEmpty } from "../utilities";
export class DataTableRequest {
    constructor(request) {
        _DataTableRequest_request.set(this, void 0);
        __classPrivateFieldSet(this, _DataTableRequest_request, request, "f");
    }
    get length() {
        return __classPrivateFieldGet(this, _DataTableRequest_request, "f").length;
    }
    get orderColumn() {
        return __classPrivateFieldGet(this, _DataTableRequest_request, "f").orderColumn;
    }
    get search() {
        return __classPrivateFieldGet(this, _DataTableRequest_request, "f").search;
    }
    get sortDirection() {
        return __classPrivateFieldGet(this, _DataTableRequest_request, "f").sortDirection;
    }
    get start() {
        return __classPrivateFieldGet(this, _DataTableRequest_request, "f").start;
    }
    toQeryString() {
        const req = __classPrivateFieldGet(this, _DataTableRequest_request, "f");
        if (req == null)
            return '';
        if (req.orderColumn > 0)
            req.orderColumn = req.orderColumn - 1;
        let apiUrl = `page=${req.start}&length=${req.length}&order=${req.orderColumn}&direction=${req.sortDirection}`;
        if (!isNullOrEmpty(req.search))
            apiUrl += `&search=${encodeURIComponent(req.search)}`;
        return apiUrl;
    }
    toJson() {
        return {
            length: this.length,
            orderColumn: this.orderColumn,
            search: this.search,
            sortDirection: this.sortDirection,
            start: this.start
        };
    }
}
_DataTableRequest_request = new WeakMap();
